import {actions} from '~utils/ngrx-util';
import {EntityConfiguracao} from '~entity/entity-configuracao/entity-configuracao.model';

const entityName = 'EntityConfig';
const {add, adds, upsert, upserts, update, updates, remove, removes, load, clear} = actions<EntityConfiguracao>(entityName);
export const addEntityConfig = add;
export const addEntityConfigs = adds;
export const upsertEntityConfig = upsert;
export const upsertEntityConfigs = upserts;
export const updateEntityConfig = update;
export const updateEntityConfigs = updates;
export const deleteEntityConfig = remove;
export const deleteEntityConfigs = removes;
export const loadEntityConfig = load;
export const clearEntityConfig = clear;
